import { useRef } from "react"

const Pagination = ({ currentPage, totalPages, selectPage, limitPage, nextPage, prevPage }) => {
    const pageRef = useRef(null)
    return (
        <div className="py-3 px-2 sm:px-4 bg-white rounded-xl flex flex-col sm:flex-row sm:justify-end gap-2">
            <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                <select
                    onChange={limitPage}
                    className="py-2.5 px-3 w-full sm:w-auto leading-tight text-base text-zafu-muted rounded-xl border border-zafu-cream-dark bg-white"
                >
                    <option value="10">Show 10</option>
                    <option value="25">Show 25</option>
                    <option value="50">Show 50</option>
                    <option value="100">Show 100</option>
                </select>

                <ul className="inline-flex -space-x-px w-full sm:w-auto justify-center">
                    <li>
                        <button
                            type="button"
                            className={"py-2.5 px-3 leading-tight text-zafu-muted rounded-l-xl border border-zafu-cream-dark text-sm " + (currentPage > 1 ? 'bg-white hover:bg-zafu-cream' : 'bg-zafu-cream-dark/50')}
                            onClick={prevPage}
                            disabled={currentPage <= 1}
                        >
                            Prev
                        </button>
                    </li>
                    {(() => {
                        if (currentPage > 6) {
                            return (
                                <li>
                                    <button type="button" onClick={selectPage.bind(this, 1)} className="py-2.5 px-3 leading-tight text-zafu-muted border border-zafu-cream-dark bg-white text-sm hover:bg-zafu-cream">1..</button>
                                </li>
                            )
                        }
                    })()}
                    {(() => {
                        let li = [];
                        let limitPageCount = 2
                        let start = currentPage > limitPageCount ? (currentPage - limitPageCount) : 1
                        let end = currentPage < (totalPages - limitPageCount) ? currentPage + limitPageCount : totalPages

                        for (start; start <= end; start++) {
                            li.push(
                                <li key={start}>
                                    <button
                                        type="button"
                                        ref={pageRef}
                                        onClick={selectPage.bind(this, start)}
                                        className={"py-2.5 px-3 leading-tight border border-zafu-cream-dark text-sm " + (currentPage === start ? 'bg-zafu-green text-white' : 'bg-white text-zafu-muted hover:bg-zafu-cream')}
                                    >
                                        {start}
                                    </button>
                                </li>
                            );
                        }

                        return li;
                    })()}
                    {(() => {
                        if (currentPage < (totalPages - 2)) {
                            return (
                                <li>
                                    <button type="button" onClick={selectPage.bind(this, totalPages)} className={"py-2.5 px-3 leading-tight text-zafu-muted border border-zafu-cream-dark text-sm " + (currentPage === totalPages ? 'bg-zafu-green text-white' : 'bg-white hover:bg-zafu-cream')}>...{totalPages}</button>
                                </li>
                            )
                        }
                    })()}
                    <li>
                        <button
                            type="button"
                            className={"py-2.5 px-3 leading-tight text-zafu-muted bg-white rounded-r-xl border border-zafu-cream-dark text-sm " + (currentPage >= totalPages ? 'bg-zafu-cream-dark/50' : 'hover:bg-zafu-cream')}
                            onClick={nextPage}
                            disabled={currentPage >= totalPages}
                        >
                            Next
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default Pagination;
